import {fetchAuthSession, signOut} from 'aws-amplify/auth';

export type FetchType = (
  path: string,
  requestConfig?: RequestInit,
) => Promise<Response>;

export type FetchWithBodyType = (
  path: string,
  body?: object | undefined,
  requestConfig?: RequestInit,
) => Promise<Response>;

export type AjaxServiceType = {
  fetch: FetchType;
  get: FetchType;
  post: FetchWithBodyType;
  put: FetchWithBodyType;
  patch: FetchWithBodyType;
  delete: FetchType;
};



const AjaxService: AjaxServiceType = {
  fetch(path, config) {

    const request = new Request(path, config);

    if (!request.headers.get('Accept-Language')) {
      request.headers.set('Accept-Language', 'en');
    }

    if (typeof config?.body === 'string') {
      request.headers.set('Content-Type', 'application/json');
    }

    return fetchAuthSession().then((session) => {
      request.headers.set('Authorisation', session?.tokens?.idToken?.toString() ?? '');
      return window.fetch(request).then((response) => {
        if (response.status === 401 || response.status === 403) {
          signOut()
              .then(() => {
                localStorage.clear();
                window.location.reload();
              }).catch(err => console.log(err));
        }
        return response;
      });
    })
  },
  get(path, requestConfig) {
    return this.fetch(path, { method: 'GET', ...requestConfig });
  },
  post(path, body, requestConfig) {
    return this.fetch(path, {
      method: 'POST',
      body: JSON.stringify(body),
      ...requestConfig,
    });
  },
  patch(path, body, requestConfig) {
    return this.fetch(path, {
      method: 'PATCH',
      body: JSON.stringify(body),
      ...requestConfig,
    });
  },
  put(path, body, requestConfig) {
    return this.fetch(path, {
      method: 'PUT',
      body: JSON.stringify(body),
      ...requestConfig,
    });
  },
  delete(path, requestConfig) {
    return this.fetch(path, { method: 'DELETE', ...requestConfig });
  },
};

export default AjaxService;
